// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View, ScrollView, TouchableWithoutFeedback } from 'react-native';
import { ActivityIndicator, Text } from 'trpc-react-native-ui';
import FormatService from '../../../../lib/format';
import theme from '../../../../theme-config';
import I18n from '../../../../lib/i18n';

type Props = {
  numbers: { ouid: string, phoneNumber: string }[],
  isFetching: boolean,
  selectedNumber: string,
  selectNumber: Function,
  renderRefreshButton: Function,
};

class AvailablePhonePicker extends PureComponent<Props> {
  styles = getStyles();

  onSelectNumber(item: { ouid: string }) {
    this.props.selectNumber(item.ouid);
  }

  render() {
    const styles = this.styles;

    if (this.props.isFetching) {
      return (
        <View style={styles.loaderContainer}>
          <ActivityIndicator color={theme.signUpTextColor} />
        </View>
      );
    }

    if (this.props.numbers.length === 0) {
      return (
        <View style={styles.textContainer}>
          <Text style={styles.noNumbersText}>{I18n.t('SignUp.ChooseNumber.noNumbers')}</Text>
        </View>
      );
    }

    return (
      <ScrollView style={styles.numbersView} contentContainerStyle={styles.numbersViewContent}>
        {this.props.numbers.map(item => (
          <TouchableWithoutFeedback key={item.ouid} onPress={() => this.onSelectNumber(item)}>
            <Text style={[styles.number, this.props.selectedNumber === item.ouid && styles.selectedNumber]}>
              {FormatService.formatPhone(item.phoneNumber)}
            </Text>
          </TouchableWithoutFeedback>
        ))}
        {this.props.renderRefreshButton && this.props.renderRefreshButton()}
      </ScrollView>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    textContainer: {
      flex: 1,
      justifyContent: 'center',
    },
    loaderContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    noNumbersText: {
      color: theme.signUpTextColor,
      textAlign: 'center',
      fontSize: 18,
      backgroundColor: 'transparent',
    },
    numbersView: {
      marginHorizontal: 5,
      marginTop: 20,
      width: '90%',
    },
    numbersViewContent: {
      paddingBottom: 10,
      alignItems: 'center',
    },
    number: {
      color: theme.signUpTextColor,
      opacity: 0.55,
      fontSize: 25,
      textAlign: 'left',
      backgroundColor: 'transparent',
      marginTop: 10,
    },
    selectedNumber: {
      opacity: 1,
      fontSize: 35,
      borderWidth: 2,
      borderColor: theme.secondaryColor,
      padding: 5
    },
  });
}

export default AvailablePhonePicker;
